import React, { useState } from "react";
import { Lock } from "react-feather";
import Button from "../../../../components/common/button";
import TwoFactorSetupModal from "./twoFactorModal";

interface IProps {
	phoneNumber: string;
}

const TwoFactorSetup: React.FC<IProps> = (props) => {
	const [showSetUpModal, setShowSetUpModal] = useState(false);

	return (
		<div className="pt-3 pb-3" style={{ width: '100%', maxWidth: '100%', overflow: 'hidden' }}>
			<Button
				type="button"
				color="primary"
				className="btn-priamry color-white"
				style={{
					color: "white",
					width: '100%',
					maxWidth: '100%',
					whiteSpace: 'normal',
					wordWrap: 'break-word',
					overflowWrap: 'break-word',
					textAlign: 'center',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexWrap: 'wrap',
					boxSizing: 'border-box'
				}}
				onClick={() => setShowSetUpModal(true)}
			>
				<div className={"d-flex align-items-center"} style={{ width: '100%', justifyContent: 'center', flexWrap: 'wrap', gap: '8px' }}>
					<Lock className="mr-2" size={16} style={{ flexShrink: 0 }} />
					<span style={{
						flex: '1',
						minWidth: '0',
						wordBreak: 'break-word',
						overflowWrap: 'break-word',
						textAlign: 'center'
					}}>
						Set up two-factor authentication
					</span>
				</div>
			</Button>
			<TwoFactorSetupModal
				phoneNumber={props.phoneNumber}
				isOpen={showSetUpModal}
				toggle={() => setShowSetUpModal(false)}
			/>
		</div>
	);
};

export default TwoFactorSetup;
